import React, { useEffect, useState } from "react";
import ContactOneInfoItem from "./ContactOneInfoItem";
import BookingRequest from "./BookingRequest";
import { useLanguage } from "../../context/LanguageContext";

// The separate-sender acceptance test confirmed replies reach the requester.
const bookingEnabled = true;

const ContactOne = () => {
  const { t } = useLanguage();
  const [isBookingOpen, setIsBookingOpen] = useState(false);

  useEffect(() => {
    if (!isBookingOpen) return undefined;
    const closeOnEscape = (event) => {
      if (event.key === "Escape") setIsBookingOpen(false);
    };
    window.addEventListener("keydown", closeOnEscape);
    return () => window.removeEventListener("keydown", closeOnEscape);
  }, [isBookingOpen]);

  const info_items = [
    ...(bookingEnabled
      ? [{
          type: "booking",
          title: t("contact.booking.title"),
          description: t("contact.booking.description"),
          contact: t("contact.booking.action"),
          onClick: () => setIsBookingOpen(true),
        }]
      : []),
    {
      type: "phone",
      title: t("contact.phone.title"),
      description: t("contact.phone.description"),
      contact: t("contact.phone.number"),
    },
    {
      type: "email",
      title: t("contact.email.title"),
      description: t("contact.email.description"),
      contact: t("contact.email.address"),
    },
  ];

  return (
    <section id="contact" className="contact-area pt-70 pb-110">
      <div className="container">
        {/* section title */}
        <div className="row justify-content-center">
          <div className="col-lg-8">
            <div className="section-title text-center mb-70">
              {/* <span className="sub-title">{t("contact.subtitle")}</span> */}
              <h2 className="title">
                {t("contact.title")
                  .split(" ")
                  .map((word, index) => {
                    if (word === "Befektetését" || word === "Investment") {
                      return (
                        <span key={index} className="text-info">
                          {word}{" "}
                        </span>
                      );
                    }
                    return <span key={index}>{word} </span>;
                  })}
              </h2>
              <p
                className="description text-light mt-4"
                style={{ fontSize: "1.1rem", lineHeight: "1.6" }}
              >
                {t("contact.description")}
              </p>
            </div>
          </div>
        </div>

        {/* secction info */}
        <div className="contact-info-wrap">
          <div className="row justify-content-center">
            {info_items.map((x, index) => (
              <div key={x.type} className={bookingEnabled ? "col-lg-4 col-sm-6" : "col-lg-6 col-sm-6"}>
                <ContactOneInfoItem item={x} />
              </div>
            ))}
          </div>
        </div>

        {/* section form */}
        {/* <ContactOneForm /> */}
      </div>
      {isBookingOpen && <BookingRequest onClose={() => setIsBookingOpen(false)} />}
    </section>
  );
};

export default ContactOne;
